import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react';
import { RichText, Image, Link } from '@sitecore-jss/sitecore-jss-react';
import Slider from "react-slick";

import { throttle } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions";

import '../../assets/css/0010_sections/0440_section-hero_formation-carousel.css'

class SectionHeroComptoirDermatoCarousel extends Component {
	constructor() {
		super()
		this.state = {
		}
		this.refreshCarouselHeight = this.refreshCarouselHeight.bind(this)
		this.handleWindowResizeheroCarousel = this.handleWindowResizeheroCarousel.bind(this)
		this.throttleWindowResizeheroCarousel = throttle(this.handleWindowResizeheroCarousel, 100)
	}
	componentDidMount(){
		window.addEventListener('resize', this.throttleWindowResizeheroCarousel)
		window.dispatchEvent(new Event('resize'))
	}
	componentWillUnmount(){
		window.removeEventListener('resize', this.throttleWindowResizeheroCarousel)
	}
	refreshCarouselHeight(){
		var heroCarousel = document.querySelector('.hero-carousel')
        if(heroCarousel){
			var slickList = heroCarousel.querySelector('.slick-list'),
			    carouselHeight = heroCarousel.clientHeight
		    slickList.style.height = carouselHeight + "px"
        }
	}
	handleWindowResizeheroCarousel() {
		this.refreshCarouselHeight()
	}
	render() {
        const { dataBanners } = this.props;
		
		const settings = {
			lazyLoad: true,
			autoplay: true,
			autoplaySpeed: 5000,
			dots: false,
			infinite: true,
			speed: 750,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
						swipeToSlide: true,
						dotsClass: "slider-nav",
						appendDots: dots => (
							<div className="slider-nav" >
								<ul> {dots} </ul>
							</div>
						),
						arrows: false,
                    }
                }
            ]
		}
		
		return (<>{dataBanners && <>
			<section className="obj_section section_hero_formation-carrousel">
				<div className="ctn_section">
					<Slider className="obj_carousel hero-carousel" {...settings}>
						{ dataBanners.map((bannerItem, index) => (
							<div key={index}>
								<div className={`obj_section_hero fade-in${bannerItem.darkMode.boolValue ? ' var_dark' : ''}${bannerItem.styleBrand.targetItem ? bannerItem.styleBrand.targetItem.brandCssClass.value : ''}${' var_' + bannerItem.align.value}`}>
									<div className="ctn_section">
                                        {/* banner type text : CAFTextBanner */}
										{ bannerItem.title &&
											<div className="ctn_text">
												{ bannerItem.posttitle.jss && <RichText tag="h2" className="t_subtitle" field={bannerItem.posttitle.jss} /> }
												{ bannerItem.ontitle.jss && <p className="t_ribbon"><span>{bannerItem.ontitle.value}</span></p> }
												{ bannerItem.title.jss && <RichText tag="h1" className="t_title" field={bannerItem.title.jss} /> }
												{ bannerItem.content.jss && <RichText tag="p" className="t_desc" field={bannerItem.content.jss} /> }
											</div>
										}
                                        {/* banner type image : CAFImageBanner */}
										{ bannerItem.image && <>
											<div className="ctn_text">
                                                { bannerItem.link.jss && bannerItem.link.jss?.value.href!== "" && <Link className={`obj_cta${bannerItem.darkMode.boolValue ? ' reverse' : ''}`} field={bannerItem.link.jss} />}
                                            </div>
                                            <picture className="ctn_background">
                                                <source srcSet={bannerItem.imageMobile.jss.value.src} media="(max-width:767px)"/>
                                                <Image field={bannerItem.image.jss}></Image>
                                            </picture>
										</>}
									</div>
								</div>
							</div>
						))}
					</Slider>
				</div>
			</section>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(SectionHeroComptoirDermatoCarousel));